import axios from 'axios';
const { REACT_APP_BOOKING_FEAT} = process.env

export const getUserBookingInstance = (baseURL:string) => {
    const bookingAxios = axios.create({
        baseURL:`https://${REACT_APP_BOOKING_FEAT}.${baseURL}`,
        timeout:10000, // 10 second timeout
    });
    return bookingAxios
}